/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { BrandDocumentDetails } from '../model/brandDocumentDetails';
import { BrandDocumentList } from '../model/brandDocumentList';
import { CreateDocument } from '../model/createDocument';
import { UpdateBrandDocument } from '../model/updateBrandDocument';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BackofficeDocumentsService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Dodawanie dokumentu przez Handlowca
     *  - __InputModelName__: CreateDocument - __InputParser__: serializer - __OperationName__: Handler - __OperationId__: CreateDocumentHandler - __Name__:  - __Path__: /backoffice/brands/{id}/documents - __Method__: POST - __Description__:  - __Summary__: Dodawanie dokumentu przez Handlowca - __RouteName__: POSTBrandDocumentDetailsHandler - __Hash__: 131394df8cb65a3f24a777c4e2cba86b - __Input__: SalesMailer\\Application\\Document\\CreateDocument - __Output__: SalesMailer\\Domain\\BrandDocument - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: BrandDocumentDetails - __OutputType__:  - __OutputFileType__:  
     * @param id 
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDocumentHandler(id: string, content?: CreateDocument, observe?: 'body', reportProgress?: boolean): Observable<BrandDocumentDetails>;
    public createDocumentHandler(id: string, content?: CreateDocument, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandDocumentDetails>>;
    public createDocumentHandler(id: string, content?: CreateDocument, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandDocumentDetails>>;
    public createDocumentHandler(id: string, content?: CreateDocument, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createDocumentHandler.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BrandDocumentDetails>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(id))}/documents`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Usuwanie dokumentu przez Administratora (przestaje być dostępny, ale plik zostaje)
     *  - __InputModelName__: DeleteBrandDocument - __Path__: /backoffice/brands/{brandId}/documents/{id} - __IsDeletableMethodName__: isDeletable - __TarEntity__:  - __EntityId__:  - __OperationName__: Handler - __OperationId__: DeleteDocumentHandler - __Name__:  - __Method__: DELETE - __Description__:  - __Summary__: Usuwanie dokumentu przez Administratora (przestaje być dostępny, ale plik zostaje) - __RouteName__: DELETEHandler - __Hash__: 494728b6f7dcf9e5dd94c0255de93f80 - __Input__: SalesMailer\\Domain\\BrandDocument - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param brandId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDocumentHandler(id: string, brandId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteDocumentHandler(id: string, brandId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteDocumentHandler(id: string, brandId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteDocumentHandler(id: string, brandId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteDocumentHandler.');
        }

        if (brandId === null || brandId === undefined) {
            throw new Error('Required parameter brandId was null or undefined when calling deleteDocumentHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(brandId))}/documents/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista dokumentów wybranej marki
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\BrandDocument - __OperationId__: DocumentListQuery - __OperationName__: ListQuery - __OutputModelName__: BrandDocumentListItem - __ListModelName__: BrandDocumentList - __DefaultSortOrder__:  - __Name__:  - __Path__: /backoffice/brands/{id}/documents - __Method__: GET - __Description__:  - __Summary__: Lista dokumentów wybranej marki - __RouteName__: GETBrandDocumentListItemListQuery - __Hash__: 05406d6bc349224d62605915d134cbbc - __Input__:  - __Output__: SalesMailer\\Domain\\BrandDocument - __InputGroups__:  - __OutputGroups__: list - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id 
     * @param page Numer strony (default: 1)
     * @param count Liczba wierszy na stronie (default: 25)
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param isArchived  (boolean, exact)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentListQuery(id: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BrandDocumentList>;
    public documentListQuery(id: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandDocumentList>>;
    public documentListQuery(id: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandDocumentList>>;
    public documentListQuery(id: string, page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling documentListQuery.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }
        if (isArchived !== undefined && isArchived !== null) {
            queryParameters = queryParameters.set('isArchived', <any>isArchived);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BrandDocumentList>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(id))}/documents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: archive - __Path__: /backoffice/brands/{brandId}/documents/{id}/archive - __InputModelName__: UpdateBrandDocument - __OperationName__: ArchiveMyDocumentHandler - __OperationId__: UpdateBrandDocumentArchiveMyDocumentHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTBrandDocumentDetailsArchiveMyDocumentHandler - __Hash__: 2fae1ac031f33ac7b37992960ce36cb8 - __Input__: SalesMailer\\Domain\\BrandDocument - __Output__: SalesMailer\\Domain\\BrandDocument - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: BrandDocumentDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param brandId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBrandDocumentArchiveMyDocumentHandler(id: string, brandId: string, observe?: 'body', reportProgress?: boolean): Observable<BrandDocumentDetails>;
    public updateBrandDocumentArchiveMyDocumentHandler(id: string, brandId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandDocumentDetails>>;
    public updateBrandDocumentArchiveMyDocumentHandler(id: string, brandId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandDocumentDetails>>;
    public updateBrandDocumentArchiveMyDocumentHandler(id: string, brandId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateBrandDocumentArchiveMyDocumentHandler.');
        }

        if (brandId === null || brandId === undefined) {
            throw new Error('Required parameter brandId was null or undefined when calling updateBrandDocumentArchiveMyDocumentHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<BrandDocumentDetails>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(brandId))}/documents/${encodeURIComponent(String(id))}/archive`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aktualizacja opisu/nazwy dokumentu
     *  - __InputParser__: method - __UpdateMethodName__: update - __Path__: /backoffice/brands/{brandId}/documents/{id} - __InputModelName__: UpdateBrandDocument - __OperationName__: Handler - __OperationId__: UpdateBrandDocumentHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__: Aktualizacja opisu/nazwy dokumentu - __RouteName__: PUTBrandDocumentDetailsHandler - __Hash__: 338efce3b5dd74ebd4828e3e5ba090c7 - __Input__: SalesMailer\\Domain\\BrandDocument - __Output__: SalesMailer\\Domain\\BrandDocument - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: BrandDocumentDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param brandId 
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBrandDocumentHandler(id: string, brandId: string, content?: UpdateBrandDocument, observe?: 'body', reportProgress?: boolean): Observable<BrandDocumentDetails>;
    public updateBrandDocumentHandler(id: string, brandId: string, content?: UpdateBrandDocument, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandDocumentDetails>>;
    public updateBrandDocumentHandler(id: string, brandId: string, content?: UpdateBrandDocument, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandDocumentDetails>>;
    public updateBrandDocumentHandler(id: string, brandId: string, content?: UpdateBrandDocument, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateBrandDocumentHandler.');
        }

        if (brandId === null || brandId === undefined) {
            throw new Error('Required parameter brandId was null or undefined when calling updateBrandDocumentHandler.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BrandDocumentDetails>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(brandId))}/documents/${encodeURIComponent(String(id))}`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: unArchive - __Path__: /backoffice/brands/{brandId}/documents/{id}/unarchive - __InputModelName__: UpdateBrandDocument - __OperationName__: UnArchiveMyDocumentHandler - __OperationId__: UpdateBrandDocumentUnArchiveMyDocumentHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTBrandDocumentDetailsUnArchiveMyDocumentHandler - __Hash__: b5c43471822739e0f70e666d989f827c - __Input__: SalesMailer\\Domain\\BrandDocument - __Output__: SalesMailer\\Domain\\BrandDocument - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: BrandDocumentDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param brandId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBrandDocumentUnArchiveMyDocumentHandler(id: string, brandId: string, observe?: 'body', reportProgress?: boolean): Observable<BrandDocumentDetails>;
    public updateBrandDocumentUnArchiveMyDocumentHandler(id: string, brandId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandDocumentDetails>>;
    public updateBrandDocumentUnArchiveMyDocumentHandler(id: string, brandId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandDocumentDetails>>;
    public updateBrandDocumentUnArchiveMyDocumentHandler(id: string, brandId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateBrandDocumentUnArchiveMyDocumentHandler.');
        }

        if (brandId === null || brandId === undefined) {
            throw new Error('Required parameter brandId was null or undefined when calling updateBrandDocumentUnArchiveMyDocumentHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<BrandDocumentDetails>(`${this.basePath}/api/backoffice/brands/${encodeURIComponent(String(brandId))}/documents/${encodeURIComponent(String(id))}/unarchive`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
